import axios from "axios";

export const AxiosHelper = axios.create({
  // baseURL: "http://localhost:5000/api",
  baseURL: process.env.REACT_APP_API_URL + "/api",
});

AxiosHelper.interceptors.request.use((request) => {
  request.headers = {
    "Content-Type": "Application/json",
  };
  return request;
});

AxiosHelper.interceptors.response.use(
  (response) => {
    return response.data;
  },
  async (error) => {
    throw new Error(error);
  }
);
